import { useMemo } from 'react';
import { Empty, Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { LineChart } from '../../common/components/LineChart';
import { chartModesConstants } from '../../common/constants/chartModes';
import { spacing } from '../../theming';
import { buildChartData, isSeriesEmpty } from '../../utils/vinExtraction';
import { cardStyle, cardTitleStyle, mutedSmallStyle } from './vinExtractionStyles';

const CHART_HEIGHT = '260px';

const emptyOverlayStyle = {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
};

/** "Success vs failed": cars per bucket over the range, Success solid, Failed and Not found dashed. */
export default function SuccessFailedChart({ series, bucket, period }) {
    const { t } = useTranslation('vinExtraction');
    const names = {
        success: t('stats.cards.success'),
        failed: t('stats.cards.failed'),
        notFound: t('stats.cards.notFound'),
    };
    const chartData = useMemo(
        () => buildChartData(series, bucket, names),
        // names change only with the language
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [series, bucket, names.success, names.failed, names.notFound]
    );
    // E10: dense zero buckets still draw the axes; the note says the period is empty rather than loading
    const empty = isSeriesEmpty(series);

    return (
        <Flex vertical gap={spacing[2]} style={{ ...cardStyle, height: '100%' }}>
            <Flex vertical>
                <span style={cardTitleStyle}>{t('stats.chart.title')}</span>
                <span style={mutedSmallStyle}>
                    {t(`stats.chart.subtitle.${bucket}`, { window: t(`stats.chart.window.${period}`) })}
                </span>
            </Flex>
            <div style={{ position: 'relative', height: CHART_HEIGHT }} role="img" aria-label={t('stats.chart.title')}>
                <LineChart chartData={chartData} mode={chartModesConstants.Analysis} />
                {empty && (
                    <div style={emptyOverlayStyle}>
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('stats.chart.empty')} />
                    </div>
                )}
            </div>
        </Flex>
    );
}
